import $ from 'jquery';
import 'slick-carousel';
import ArrowBigNext from '../../../img/rolex-v7/icons/rlx-v7-arrow--right.svg';

export default function rlxSlider() {
    const mediumBreakpoint = 767;
    const largeBreakpoint = 1024;

    // --- Translation Helper Function ---
    const getSliderA11yText = ($sliderElement) => {
        const nextText = $sliderElement.data('js-a11y-next-slide') || 'Next Slide';
        const prevText = $sliderElement.data('js-a11y-previous-slide') || 'Previous Slide';
        return { nextText, prevText };
    };

    // --- SLIDER 1: Keep Exploring List Slider (.js-rlx-v7-keep-exploring__slide) ---

    const $keepExploringSlider = $('.js-rlx-v7-keep-exploring__slide').not('.slick-initialized').first();

    if ($keepExploringSlider.length) {
        // eslint-disable-next-line max-len
        const { nextText: keepExploringNextText, prevText: keepExploringPrevText } = getSliderA11yText($keepExploringSlider);

        // Define the translated button HTML for the first slider
        const nextArrowHtml1 = `<button type="button" class="slick-next rlx-v7-icon-button rlx-v7-icon-button--round is-dark"><span class="rlx-v7-icon-button__icon">${ArrowBigNext}</span><span class="_visuallyhidden js-a11y-next-slide">
            ${keepExploringNextText}</span></button>`;
        const prevArrowHtml1 = `<button type="button" class="slick-prev rlx-v7-icon-button rlx-v7-icon-button--round is-dark"><span class="rlx-v7-icon-button__icon">${ArrowBigNext}</span><span class="_visuallyhidden js-a11y-previous-slide">
            ${keepExploringPrevText}</span></button>`;

        $keepExploringSlider.slick({
            infinite: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            // Use the translated HTML
            nextArrow: nextArrowHtml1,
            prevArrow: prevArrowHtml1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: mediumBreakpoint,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: largeBreakpoint,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    },
                },
            ],
        });
    }

    // --- SLIDER 2: Image/Text fullwidth (.js-rlx-v7-slider-component__slide) ---

    const toggleDarkModeClass = (slider, isDarkMode) => {
        const buttons = slider.querySelectorAll('.rlx-v7-icon-button');
        buttons.forEach((button) => {
            button.classList.toggle('is-dark', isDarkMode);
        });
        slider.classList.toggle('mode--dark', isDarkMode);
    };

    const $componentSlider = $('.js-rlx-v7-slider-component__slide').not('.slick-initialized').first();

    if ($componentSlider.length) {
        // Read translations from the component slider element
        // eslint-disable-next-line max-len
        const { nextText: componentNextText, prevText: componentPrevText } = getSliderA11yText($componentSlider);

        // Define the translated button HTML for the second slider
        const nextArrowHtml2 = `<button type="button" class="slick-next rlx-v7-icon-button rlx-v7-icon-button--round"><span class="rlx-v7-icon-button__icon">${ArrowBigNext}</span><span class="_visuallyhidden js-a11y-next-slide">
            ${componentNextText}</span></button>`;
        const prevArrowHtml2 = `<button type="button" class="slick-prev rlx-v7-icon-button rlx-v7-icon-button--round"><span class="rlx-v7-icon-button__icon">${ArrowBigNext}</span><span class="_visuallyhidden js-a11y-previous-slide">
            ${componentPrevText}</span></button>`;

        $componentSlider.on('init', function () {
            const $currentSlide = $(this).find('.slick-slide.slick-current');
            const $isDarkMode = $currentSlide.find('[data-dark-mode]').length;
            toggleDarkModeClass(this, $isDarkMode);
        });

        $componentSlider.slick({
            infinite: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            // Use the translated HTML
            nextArrow: nextArrowHtml2,
            prevArrow: prevArrowHtml2,
            mobileFirst: true,
        });

        $componentSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const $nextSlide = $(slick.$slides[nextSlide]);
            const $isDarkMode = $nextSlide.find('[data-dark-mode]').length;
            toggleDarkModeClass(this, $isDarkMode);
        });
    }
}
